module.exports = __webpack_public_path__ + "media/assets/svg/logos/email-solid-2175b2a5af92be9af27bd6149c3d2cd1.svg";